import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=ce3edfde&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=ce3edfde&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3edfde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce3edfde')) {
      api.createRecord('ce3edfde', component.options)
    } else {
      api.reload('ce3edfde', component.options)
    }
    module.hot.accept("./BaseModal.vue?vue&type=template&id=ce3edfde&scoped=true", function () {
      api.rerender('ce3edfde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/BaseModal.vue"
export default component.exports